import { render } from "./telegram.vue?vue&type=template&id=66b271b6"
import script from "./telegram.vue?vue&type=script&lang=js"
export * from "./telegram.vue?vue&type=script&lang=js"

import "./telegram.vue?vue&type=style&index=0&id=66b271b6&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__